import React from 'react';
import { connect } from 'react-redux';
import '../../styles/promotion.scss';
import Cookies from 'universal-cookie';
import Navbar from './play_Navbar';
import { Navigate } from 'react-router-dom';
import config from '../../configuration.json';
class Signed extends React.Component {

    state = {
        scale: false,
        useNavigation: null,
    };
    componentDidMount() {
        window.scrollTo(0, 0);
        this.cookies = new Cookies();
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        if (window.innerWidth <= 760) {
            this.setState({ scale: true });
        }
        else {
            this.setState({ scale: false });
        }
    }

    goBack() {
        this.setState({ useNavigation: <Navigate to={`/${process.env.REACT_APP_HOME}`} replace={true} /> });
    }

    render() {
        return (
            <div className='row'>
                {this.state.useNavigation}
                <Navbar image={config.PlayAndPizza.HeaderIconlUrl} />
                <div style={{ textAlign: 'center', marginTop: '30%' }}>
                    <h3 style={{ fontFamily: 'Roboto', fontWeight: 'bolder', fontSize: '25px' }}>{config.PlayAndPizza.Signed.Title}</h3>
                    <div style={{ fontFamily: 'Roboto', fontSize: '14px', width: '80%', margin: 'auto', fontWeight: 500, marginTop: '20px' }} className='play_signed_detail'
                        dangerouslySetInnerHTML={{ __html: config.PlayAndPizza.Signed.Detail }}></div>
                </div>
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <button className="btn play_button" onClick={() => {
                        window.gtag('event', 'Signed', { 'eventCategory': 'Signed', 'eventLabel': 'Signed' });
                        this.goBack();
                    }}>{config.PlayAndPizza.Signed.ButtonText}</button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
    };
};

export default connect(mapStateToProps, {})(Signed);


